<div class="wrapper-construction">
  <ng-container *ngIf="status === 'loading'">
    <div class="circle-container">
      <div class="circle-loader"></div>
    </div>
  </ng-container>

  <div class="construction-site-root" *ngIf="status === 'idle'">
    <div class="construction-site-header">


      <div class="col-item title">Chantier</div>

      <div class="col-stats-container">
        <div class="col-item stats">
          <span class="stats-left">{{ dueRealisedNumber }} / {{ subjects?.length }}</span>
          <span class="stats-right">Actions<br />réalisées</span>
        </div>
        <div class="separator"></div>
        <div class="col-item stats">
          <span class="stats-left">{{ dueEchueNumber }}</span>
          <span class="stats-right">échéances<br />echues</span>
        </div>
      </div>

      <div class="photo-text col-item stats" *ngIf="worksite">
        <span class="stats-left">
          <div class="showroom-image lw-rounded">
            <div class="image" [ngStyle]="{ 'background-image': 'url(' + worksite?.avatar + ')' }"></div>
          </div>
        </span>
        <span class="stats-right">Resp. travaux<br />
          {{ worksite?.first_name }}.{{ worksite?.last_name }}</span>
      </div>
    </div>

    <div class="construction-content">
      <div class="construction-site-second-header">
        <img src="/assets/images/schedule_header_2.svg" />
        <div class="separator"></div>
        <p *ngIf="owner" class="title">
          Bonjour {{ owner?.first_name }} {{ owner?.last_name }},<br />Voici les activités de votre chantier.
        </p>
      </div>

      <div class="subjects-header">
        <span>Vous avez {{ subjects?.length }} sujets de chantier prévus.</span><button (click)="remarkEnabled = true">J'ai
        une remarque</button>
      </div>

      <app-construction-site-list *ngIf="currentProject" [subjects]="subjects" [users]="currentProject._related._project_user_roles">
      </app-construction-site-list>

      <div class="remark-container" *ngIf="remarkEnabled">
        <app-construction-site-remark [projectId]="currentProject.id" (close)="onUpdateListSubjects($event)">
        </app-construction-site-remark>
      </div>
    </div>
  </div>
</div>
